import { ChartBubbleIcon } from './ChartBubbleIcon';

/**
 * author: Google
 * id 9D79A433-CF5A-45A2-971F-4FBF72DB9821
 * name chart-bubble
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-bubble.svg
 * tags
 * - Math 
 */
export const ReportBubbleIcon = ChartBubbleIcon;
export default ReportBubbleIcon